<template>
  <a-spin :spinning="spinning">
    <div class="result">
      <div class="content">
        <div class="failed">
          <img class="status" src="../../../../assets/images/checkout/success.png" />
          <div class="title">{{ $t('message.subscribe.unsubscribeSuccessTip') }}</div>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import Loading from '@/components/loading'

export default {
  components: { Loading },
  data() {
    return {
      id: this.$route.params.id,
      spinning: false
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="less" scoped>
@import '~@/styles/common.less';

.result {
  padding-top: 37px;

  .content {
    width: 886px;
    height: 666px;
    background: @white;
    box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.11);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    .title {
      #Font.heavy();
      font-size: 16px;
      line-height: 22px;
      color: @checkout-more-color;
    }
  }
}

@media screen and(max-width: 900px) {
  .result {
    padding: 37px 20px 0;

    .content {
      width: 100%;
      height: fit-content;
      display: block;
      padding-bottom: 35px;
    }

    .btns {
      margin-top: 20px;
      display: block;
    }
  }
}
</style>
